var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"passworld",class:{
      typewriter: _vm.typewriter,
      deleteTypewriter: _vm.deleteTypewriter,
    }},[_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('br'),_c('p')])])])}
var staticRenderFns = []

export { render, staticRenderFns }